/**
 * 统一日期格式化（用户控制台 + 管理后台共用）
 *
 * 输出本地时间：formatDateTime → "2026-10-07 14:05"，formatDate → "2026-10-07"。
 * 接受：ISO 字符串（含 Z / 微秒）、"YYYY-MM-DD HH:mm:ss"、Date、Unix 秒或毫秒时间戳。
 * 空值 / 无法解析 → empty（默认 "-"），不会渲染 "Invalid Date"。
 */
import dayjs from 'dayjs';

const toDayjs = (value) => {
    if (value === null || value === undefined || value === '' || value === 0 || value === '0') return null;
    if (dayjs.isDayjs(value)) return value;
    if (value instanceof Date) return dayjs(value);
    if (typeof value === 'number' || /^\d{9,13}$/.test(String(value))) {
        const n = Number(value);
        return dayjs(n < 1e11 ? n * 1000 : n);
    }
    const s = String(value).trim();
    if (s.startsWith('0000-00-00')) return null;
    const d = dayjs(s);
    if (d.isValid()) return d;
    const native = new Date(s);
    return Number.isNaN(native.getTime()) ? null : dayjs(native);
};

export const formatDateTime = (value, { empty = '-', seconds = false } = {}) => {
    const d = toDayjs(value);
    return d && d.isValid() ? d.format(seconds ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD HH:mm') : empty;
};

export const formatDate = (value, { empty = '-' } = {}) => {
    const d = toDayjs(value);
    return d && d.isValid() ? d.format('YYYY-MM-DD') : empty;
};

/** 相对时间（"3 天前"）需要 relativeTime 插件时再扩展；这里只提供天数差，避免额外依赖。 */
export const daysUntil = (value) => {
    const d = toDayjs(value);
    return d && d.isValid() ? Math.ceil(d.diff(dayjs(), 'hour') / 24) : null;
};

export default formatDateTime;
